var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgYahoo = function SvgYahoo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3h5.104l2.972 7.604L15.086 3h4.97l-7.483 18H7.572l2.048-4.77L4 3z",
    fill: "#A4B8D1"
  })));
};

export default SvgYahoo;